"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = void 0;
var fetcher_1 = require("@nestia/fetcher");
Object.defineProperty(exports, "HttpError", { enumerable: true, get: function () { return fetcher_1.HttpError; } });
//# sourceMappingURL=HttpError.js.map